import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import CustomButton from '../widgets/CustomButton';

interface UpdateNotificationProps {
  open: boolean;
  onReload: () => void;
  onClose?: () => void;
  latestVersion?: string | null;
}

export const UpdateNotification: React.FC<UpdateNotificationProps> = ({
  open,
  onReload,
  onClose,
  latestVersion,
}) => {
  const handleClose = () => {
    // Store dismissed version when user closes without reloading
    if (latestVersion) {
      localStorage.setItem('dismissedVersion', latestVersion);
      console.log('💾 User dismissed update notification for version:', latestVersion);
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={handleClose}
      sx={{
        // Add safe area inset for iOS PWA top notch
        top: 'calc(var(--safe-area-inset-top) + 16px)',
      }}
    >
      <Alert
        severity="info"
        variant='filled'
        sx={{ 
          width: '100%', 
          py: '10px',px: '18px',
          alignItems: 'center', 
          fontSize: '14px',
          fontWeight: 550,
          bgcolor: 'rgba(0, 75, 28, 0.52)', 
          backdropFilter : 'blur(10px)',
          borderColor: '#ffffff2d',
          borderRadius: '16px',
          borderStyle: 'solid',
          borderWidth: '1px',
          color: '#ffffffde' }}
        action={
          <CustomButton
            semantic="success"
            size="small"
            onClick={onReload}
            sx={{
              color: '#2a2a2aff !important',
            }}
          >
            Reload
          </CustomButton>
        }
      >
        {latestVersion
          ? `A new version of Watchlist is available!`
          : 'A new version is available!'}
      </Alert>
    </Snackbar>
  );
};
